import { SALE_GUIDE_LIST } from 'shared/constants/guide';
import { GuideItem } from '../GuideItem';
import * as style from './GuideList.css';
import { useDeviceType } from '@cian/ui-kit';
import classnames from 'classnames';

export const GuideList: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={classnames(style['container'], device === 'phone' && style['container-phone'])}>
      {SALE_GUIDE_LIST.map(item => (
        <GuideItem key={item.step} {...item} />
      ))}
    </div>
  );
};
